define('views/offer-page-view',[
  'jquery',

  'modules/overlay-box',
  'modules/options-menu',
  'modules/order-matrix',
  'modules/customer-logo-upload',

  'connections/offer-connection',
  'connections/product-connection',

  'utils/view',
  'utils/tooltip-init',
  'utils/pikaday-i18n',
  'utils/toast',

  'pikaday',
  'server-settings'
], function (
  $,
  OverlayBox,
  OptionsMenu,
  OrderMatrix,
  CustomerLogoUpload,
  OfferConnection,
  ProductConnection,
  View,
  tooltipInit,
  pikadayi18n,
  toast,
  Pikaday,
  settings
) {
  var _this;
  var OfferPageView = (function () {
    function OfferPageView() {
      _this = this;
    }

    /**
     * Initializes the offer bindings.
     *
     * @method _init
     * @private
     */
    OfferPageView.prototype._init = function () {
      this.offerId = $('#offer-container').data('offer-id');
      this.initBindings();
      this.initTooltips();

      this.matrices = {};

      this.dirtyPreview = false;
      $('#offer-container').find('[data-offer-loader]').hide();
      $('#offer-container').find('[data-offer-content]').show();
    };

    OfferPageView.prototype.initPublicUrl = function ($offerContainer) {
      var setPublicUrlResult = function (html) {
        $offerContainer.find('.public-offer-url').html(html);
      };

      // Remove button
      $offerContainer.on('click', '[data-action="removePublicUrl"]', function (e) {
        e.preventDefault();
        OfferConnection.removePublicUrl(_this.offerId).then(setPublicUrlResult);
      });

      // Create button
      $offerContainer.on('click', '[data-action="createPublicUrl"]', function (e) {
        e.preventDefault();
        OfferConnection.createPublicUrl(_this.offerId).then(setPublicUrlResult);
      });
    };

    OfferPageView.prototype.initPdfSettings = function ($offerContainer) {
      $form = $('#viewSettingsForm');
      $loader = $form.find('[data-pdf-settings-loader]');

      function saveForm(e) {
        if (e) e.preventDefault();

        var formData = new FormData($form.get(0));
        $loader.removeClass('hidden');

        OfferConnection.updateViewSettings(formData).then(function () {
          _this.dirtyPreview = true;
          $loader.addClass('hidden');
        });
      }

      // Bind form save
      $form.on('submit', saveForm);
      $form.on('change', saveForm);

      // Bind image-select
      $(document).on('click', '[data-select-image]', function () {
        var $img = $(this);
        var imagetype = $img.data('selectImage');
        var imagevalue = $img.data('selectImageValue').toString();
        var $hiddenInput = $('[data-pdf-imageselect=' + imagetype + ']');
        var currentVal = $hiddenInput.val();

        if (imagevalue === currentVal) {
          $hiddenInput.val(null);
          $img.removeClass('coverimage--selected');
        } else {
          $hiddenInput.val(imagevalue);
          $img.addClass('coverimage--selected');
          $img.siblings('[data-select-image]').removeClass('coverimage--selected');
        }

        saveForm();
      });

      // Bind multi-image-select
      $(document).on('click', '[data-select-images]', function () {
        var $img = $(this);

        var $imagesSelector = $img.parents('[data-pdf-images-selector]');
        var $input = $imagesSelector.find('[data-pdf-images]');

        if ($img.hasClass('coverimage--selected')) $img.removeClass('coverimage--selected');
        else $img.addClass('coverimage--selected');

        var $selectedimages = $imagesSelector.find('[data-select-images].coverimage--selected');

        var sources = $selectedimages.map(function () {
          return $(this).data('selectImages');
        });
        var sourceValue = sources.get().join(',');

        $input.val(sourceValue);

        saveForm();
      });

      // Bind logo upload
      new CustomerLogoUpload(
        $('[data-add-customer-logo]'),
        function (image) {
          var $logoSelectors = $('[data-logo-selector]');

          $logoSelectors.each(function () {
            var imageType = $(this).data('logoSelector');

            $(this).prepend(_this.getLogoTemplate(image.URL, image.ID, imageType));
          });
        },
        function (error) {
          console.log('error', error);
          toast.queueError('Could not upload image, please try again or contact customer service');
        }
      );

      // Bind edit sections
      $(document).on('click', '[data-pdf-edit]', function () {
        var section = $(this).data('pdfEdit');
        var $section = $('[data-edit-section=' + section + ']');
        var $this = $(this);

        function scrollIfNeeded() {
          if ($this.is('a') && window.innerWidth < 768) {
            $('html, body').animate(
              {
                scrollTop: $section.offset().top - 200
              },
              400,
              function () {}
            );
          }
        }

        if ($this.is('[type="checkbox"]') && !$this.is(':checked')) {
          $section.fadeOut(150);
        } else {
          $visibleSection = $('[data-edit-section]').filter(':visible');
          if ($visibleSection.length && $visibleSection.data('editSection') !== section) {
            $visibleSection.fadeOut('fast', function () {
              $section.fadeIn(150);
              scrollIfNeeded();
            });
          } else {
            $section.fadeIn(150);
            scrollIfNeeded();
          }
        }
      });

      function toggleEditButton() {
        var $checkbox = $(this);
        var $cog = $checkbox.parent().siblings('a[data-pdf-edit]');
        if ($checkbox.is(':checked')) {
          $cog.show();
        } else {
          $cog.hide();
        }
      }

      $('input[type=checkbox][data-pdf-edit]').on('change', toggleEditButton);

      $('[data-select-all]').on('click', function () {
        var checkboxes = $(this).parents('[data-section]').find('input[type=checkbox]');
        var checked = $(this).parents('[data-section]').find('input[type=checkbox]:checked');

        if (checkboxes.length > checked.length) {
          checkboxes.prop('checked', true);
        } else {
          checkboxes.prop('checked', false);
        }

        checkboxes.each(toggleEditButton);
        saveForm();
      });

      // Reload preview on click
      $(document).on('click', '[data-pdf-preview-tab]', function () {
        if (!_this.dirtyPreview) return;

        $('[data-preview-loader]').show();
        $('[data-pdf-preview]').hide();

        var $tabContent = $(this).parents('.tab').find('[data-pdf-preview]');
        OfferConnection.getOfferPdfPreview(_this.offerId).then(function (res) {
          $('[data-preview-loader]').hide();
          $('[data-pdf-preview]').show();
          $tabContent.html(res);
          _this.dirtyPreview = false;
        });
      });
    };

    OfferPageView.prototype.initBindings = function () {
      var $offerContainer = $('#offer-container');

      // Title
      $offerContainer.on('click', '[data-name-btn-edit]', this.changeOfferNameClick);
      $offerContainer.on('click', '[data-name-btn-check]', this.changeOfferNameChange);
      $offerContainer.on('change', '[data-name-input]', this.changeOfferNameChange);

      // Actions
      $offerContainer.on('click', '[data-action="addproductstocart"]', this.addProductsToCart);

      // All products
      $offerContainer.on('click', '[data-percent-all-btn]', this.updatePercentAll);
      $offerContainer.on('change', '[data-percent-all-input]', _this.updatePercentAll);

      // Product options
      $offerContainer.on('click', '.offer-view__options', OptionsMenu.toggle);
      OptionsMenu.addBodyCloseListener('.offer-view__options');
      $offerContainer.on('click', '.add-logo-btn', this.toggleLogoInput);
      $offerContainer.on('click', '.add-application-btn', this.toggleApplicationCostInput);
      $offerContainer.on('click', '.add-comment-btn', this.toggleCommentInput);
      $offerContainer.on('click', '.add-pricerow-btn', this.togglePriceRowInput);
      $offerContainer.on('click', '.add-articles-btn', this.showMatrix);

      // Product inputs
      $offerContainer.on('click', '.apply-matrix', this.applyMatrix);
      $offerContainer.on('click', '.product-remove', this.removeProduct);
      $offerContainer.on('click', '.item-remove', this.removeItem);
      $offerContainer.on('change', '.cart-article__quantity', this.updateQuantity);
      $offerContainer.on('change', '.cart-article__new-price', this.updateNewSkuPrice);
      $offerContainer.on('change', '.cart-product__new-price', this.updateNewProductPrice);
      $offerContainer.on('change', '.cart-product__percent', this.updatePercent);
      $offerContainer.on('change', 'input.comment', this.updateComment);
      $offerContainer.on('change', '.cart-product__cost', this.updateCostRows);
      $offerContainer.on('click', '.cost-remove', this.removeCostRow);
      $offerContainer.on('click', '.comment-remove', this.removeComment);
      $offerContainer.on('click', '.logos-remove', this.removeLogos);

      // PDF
      this.initPdfSettings($offerContainer);

      // Public offer URL
      this.initPublicUrl($offerContainer);

      // Add new product
      $offerContainer.on('click', '.cart-addproduct-activate', function (e) {
        e.preventDefault();
        $(this).hide().next().show().find('[name=skunumber]').focus();
      });

      $offerContainer.on('click', '.cart-addproduct-add', function (e) {
        var $button = $(this);
        $button.attr('disabled', 'disabled');

        e.preventDefault();
        var sku = $offerContainer.find('.cart-addproduct-sku').val();
        OfferConnection.addProduct(_this.offerId, sku)
          .then(function (res, status, xhr) {
            if (xhr.status === 200 && typeof res === 'string') {
              var newProductEl = $(res);
              var productNumber = newProductEl.data('product-number');
              var $existingProduct = $offerContainer.find('[data-product-number="' + productNumber + '"]');
              if ($existingProduct.data('product-number')) {
                $existingProduct.replaceWith(newProductEl);
              } else {
                var allProducts = $offerContainer.find('.cart-product[data-product-number]');
                if (allProducts.length > 0) {
                  allProducts.last().after(newProductEl);
                } else {
                  $offerContainer.find('.cart-container').prepend(newProductEl);
                }
              }
              OfferConnection.getSum(_this.offerId).then(function (offerSum) {
                _this.updateOfferSum(offerSum);
              });
            } else {
              toast.queueError(xhr.statusText, 4000);
            }
          })
          .always(function () {
            $button.removeAttr('disabled');
          });
      });

      // Preview scroll to page
      $('[data-pdf-link]').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var hash = this.hash;
        if ($(hash).length) {
          $('html, body').animate(
            {
              scrollTop: $(hash).offset().top - 100
            },
            300,
            function () {}
          );
        }
      });

      // Init Expiration
      this.initDatePicker();
      $('[data-expiration-offset]').on('change', this.updateExpiration);
    };

    OfferPageView.prototype.initDatePicker = function () {
      var $input = $('[data-expiration-date]');
      var $removeBtn = $('[data-expiration-remove]');
      var field = $input[0];

      $input.attr('autocomplete', 'off');
      this.picker = new Pikaday({
        field: field,
        firstDay: 1,
        i18n: pikadayi18n,
        onSelect: _this.updateExpiration
      });

      $removeBtn.on('click', function () {
        _this.picker.setDate(null);
        _this.updateExpiration();
      });
    };

    /**
     * Opens the open as cart popup.
     *
     * @method openAsCartPopup
     */
    OfferPageView.prototype.openAsCartPopup = function () {
      var ob = new OverlayBox($('#  '), {});

      ob.setup();
      ob.load(function () {
        $('#cancelConvert').one('click', function () {
          ob.destroy();
        });
        $('#continueConvert').one('click', _this.openAsCart);

        ob.show();
      });
    };

    OfferPageView.prototype.addProductsToCart = function () {
      OfferConnection.addProductsToCart(_this.offerId).then(function (res) {
        if (typeof res === 'string') window.location.href = res;
      });
    };

    OfferPageView.prototype.updateExpiration = function () {
      var date = _this.picker.getDate();
      var offsetInput = $('[data-expiration-offset]');
      var unixTimeStamp = date ? date.getTime() : null;
      var $loader = $('[data-expiration-loader]');

      $loader.removeClass('hidden');
      OfferConnection.changeExpiration({
        offerId: _this.offerId,
        expiryDate: unixTimeStamp,
        expiryOffset: offsetInput.val()
      }).always(function () {
        $loader.addClass('hidden');
        _this.dirtyPreview = true;
      });
    };

    OfferPageView.prototype.initTooltips = function () {
      // Prevent binding on touch devices.
      if (!Modernizr.touch) tooltipInit($('#offer-container'));
    };

    OfferPageView.prototype.toggleApplicationCostInput = function (e) {
      _this.togglePriceRowInput(e, true);
    };

    OfferPageView.prototype.toggleCommentInput = function (e) {
      e.preventDefault();

      var productEl = $(e.target).closest('.cart-product');
      var commentRow = productEl.find('.cart-product__comment');

      commentRow.slideDown(200, function () {
        commentRow.find('input').focus();
      });
    };

    OfferPageView.prototype.togglePriceRowInput = function (e, isApplication) {
      e.preventDefault();

      var productEl = $(e.target).closest('.cart-product');
      var priceRowTemplate = $('#priceRowTemplate').html();
      var priceRow = $(priceRowTemplate);

      var application = priceRow.find('.cost__name--application');
      var description = priceRow.find('.cost__name--description');
      var costSku = priceRow.find('.cost-mapping');
      var costDescription = priceRow.find('.cost-description');
      var haveCostSku = costSku.length > 0;

      if (!haveCostSku) costDescription.removeClass('col-wrapper-sixth').addClass('col-wrapper-third');

      if (isApplication) {
        application.show();
        application.next().hide();
        description.children().remove();
      } else {
        application.remove();
      }

      priceRow.appendTo(productEl);
      priceRow.slideDown(200, function () {
        priceRow.find('input').first().focus();
      });
    };

    OfferPageView.prototype.updateComment = function () {
      var comment = $(this).val();
      var productEl = $(this).closest('.cart-product');
      var productNumber = productEl.data('product-number');
      var loader = productEl.find('[data-product-loader]');

      loader.show();
      OfferConnection.changeComment({ offerId: _this.offerId, productNumber: productNumber, comment: comment }).always(
        function () {
          _this.dirtyPreview = true;
          loader.hide();
        }
      );
    };

    OfferPageView.prototype.updateCostRows = function (e) {
      var productEl = $(e.target).closest('.cart-product');
      var productNumber = productEl.data('product-number');
      var loader = productEl.find('[data-product-loader]');

      loader.show();
      OfferConnection.changeCostRows({
        offerId: _this.offerId,
        productNumber: productNumber,
        costLines: _this.getCostRows(productEl)
      })
        .then(function (sum) {
          _this.updateOfferSum(sum);
        })
        .always(function () {
          loader.hide();
        });
    };

    OfferPageView.prototype.getCostRows = function (el) {
      var costRows = [];

      el.find('.cart-product__cost').each(function (i, el) {
        var nameEl = $(this).find('.cost__name');
        var name = nameEl.val() || nameEl.text();
        var cost = $(this).find('.cost__cost').val();
        var qty = $(this).find('.cost__qty').val();
        var sku = $(this).find('.cost__sku').val();
        if (name && cost && qty) costRows.push({ description: name, cost: cost, quantity: qty, costSku: sku });
      });

      return costRows;
    };

    OfferPageView.prototype.removeCostRow = function (e) {
      var row = $(this).closest('.cart-product__cost');
      row.find('input').val('');
      row.slideUp(200);

      // TODO: if error removing?
      _this.updateCostRows(e);
    };

    OfferPageView.prototype.removeComment = function (e) {
      var row = $(this).closest('.cart-product__comment');
      var input = row.find('input');
      input.val('');
      row.slideUp(200);
      input.trigger('change');
    };

    OfferPageView.prototype.updateNewSkuPrice = function (e) {
      var productEl = $(this).closest('.cart-product');
      var skuEl = $(this).closest('.cart-product__item');
      var sku = skuEl.data('sku');
      var value = $(this).val() || '0';
      var loader = productEl.find('[data-product-loader]');

      loader.show();
      OfferConnection.changeSkuPrice({ offerId: _this.offerId, sku: sku, price: value })
        .then(function (offerResult) {
          _this.updateOfferValues(offerResult);
        })
        .always(function () {
          loader.hide();
        });
    };

    OfferPageView.prototype.updateNewProductPrice = function (e) {
      var productEl = $(this).closest('.cart-product');
      var productNumber = productEl.data('product-number');
      var value = $(this).val() || '0';
      var loader = productEl.find('[data-product-loader]');

      loader.show();
      OfferConnection.changeProductPrice({ offerId: _this.offerId, productNumber: productNumber, price: value })
        .then(function (offerResult) {
          _this.updateOfferValues(offerResult);
        })
        .always(function () {
          loader.hide();
        });
    };

    OfferPageView.prototype.updatePercent = function (e) {
      var $el = $(e.target);
      var productEl = $el.closest('.cart-product');
      var productNumber = productEl.data('product-number');
      var value = $el.val();
      if (!value) return;

      var loader = productEl.find('[data-product-loader]');
      loader.show();
      OfferConnection.changePercent({ offerId: _this.offerId, productNumber: productNumber, percent: value })
        .then(function (offerResult) {
          _this.updateOfferValues(offerResult);
        })
        .always(function () {
          loader.hide();
        });
    };

    OfferPageView.prototype.changeOfferNameClick = function () {
      $('[data-name-view]').hide();
      $('[data-name-edit]').show();
    };

    OfferPageView.prototype.changeOfferNameChange = function () {
      var $inputEl = $('[data-name-input]');
      var value = $inputEl.val();
      if (!value) return;
      var $loader = $('[data-name-loader]');
      var $btn = $('[data-name-btn-check]');
      $loader.show();
      $btn.hide();
      OfferConnection.changeName(_this.offerId, value)
        .then(function (res) {})
        .always(function () {
          $loader.hide();
          $btn.show();
          $('[data-name-text]').text(value);
          $('[data-name-view]').show();
          $('[data-name-edit]').hide();
        });
    };

    OfferPageView.prototype.updatePercentAll = function () {
      var $inputEl = $('[data-percent-all-input]');
      var $btn = $('[data-percent-all-btn]');
      var value = $inputEl.val();
      if (!value) return;

      var $loader = $('<span class="loader"></span>');
      var $icon = $btn.children().replaceWith($loader);
      OfferConnection.changePercent({ offerId: _this.offerId, percent: value })
        .then(function (offerResult) {
          _this.updateOfferValues(offerResult);
        })
        .always(function () {
          $loader.replaceWith($icon);
        });
    };

    OfferPageView.prototype.updateOfferValues = function (offerResult) {
      var $offerContainer = $('#offer-container');

      $.each(offerResult.products, function (i, product) {
        // var product = offerResult.products[i];
        var $p = $offerContainer.find('[data-product-number="' + product.productNumber + '"]');
        $p.find('.cart-product__new-price').val(product.newPrice);
        $p.find('.cart-product__percent').val(product.percent);
        $p.find('.cart-product__total-price-new').text(product.newTotalPrice);
        $p.find('.cart-product__total-qty').text(product.totalQuantity);
        $p.find('.cart-product__total-price').text(product.totalPrice);

        product.skus.forEach(function (sku) {
          var $s = $p.find('[data-sku="' + sku.sku + '"]');
          $s.find('.cart-article__quantity').val(sku.totalQuantity);
          $s.find('.cart-article__new-price').val(sku.newPrice);
          $s.find('.cart-article__total-price-new').text(sku.newTotalPrice);
        });
      });

      _this.updateOfferSum(offerResult.sum);
    };

    OfferPageView.prototype.removeProduct = function (e) {
      var productEl = $(e.target).closest('.cart-product');
      var productNumber = productEl.data('product-number');
      var loader = productEl.find('[data-product-loader]');

      loader.show();
      OfferConnection.deleteProduct({ offerId: _this.offerId, productNumber: productNumber })
        .then(function (sum) {
          productEl.remove();
          _this.updateOfferSum(sum);
        })
        .always(function () {
          loader.hide();
        });
    };

    OfferPageView.prototype.updateQuantity = function (e) {
      var $el = $(e.target);
      var qty = $el.val();
      if (qty <= 0) {
        _this.removeItem(e);
        return;
      }
      var productEl = $el.closest('.cart-product');
      var sku = $el.closest('.cart-product__item').data('sku');
      _this.changeQuantity(productEl, sku, qty);
    };

    OfferPageView.prototype.removeItem = function (e) {
      var productEl = $(e.target).closest('.cart-product');
      if (productEl.find('.cart-product__item[data-sku]').length < 2) return _this.removeProduct(e);
      var itemEl = $(e.target).closest('.cart-product__item');
      var sku = itemEl.data('sku');
      var loader = productEl.find('[data-product-loader]');
      loader.show();
      _this
        .changeQuantity(productEl, sku, 0)
        .then(function () {
          itemEl.remove();
        })
        .always(function () {
          loader.hide();
        });
    };

    OfferPageView.prototype.changeQuantity = function (productEl, sku, qty) {
      var loader = productEl.find('[data-product-loader]');
      loader.show();
      return OfferConnection.changeQuantity({ offerId: _this.offerId, sku: sku, quantity: qty })
        .then(function (offerResult) {
          _this.updateOfferValues(offerResult);
        })
        .always(function () {
          loader.hide();
        });
    };

    OfferPageView.prototype.logoSelectBind = function () {
      $('#addMyLogos').on('click', '.img', function () {
        if ($('div.selected > .img').length < 4 || $(this).parent('div').hasClass('selected')) {
          $(this).parent('div').toggleClass('selected');
        }
      });
    };

    OfferPageView.prototype.updateLogos = function (productEl, productNumber, selectedLogos) {
      var logoRow = productEl.find('.cart-product__logos');
      var loader = productEl.find('[data-product-loader]');

      loader.show();
      logoRow.slideDown(200);
      OfferConnection.changeLogoApplication({
        offerId: _this.offerId,
        productNumber: productNumber,
        logoImages: selectedLogos
      })
        .then(function (res) {
          logoRow.find('.product-image-holder').closest('.col-wrapper-sixth').remove();
          _this.dirtyPreview = true;

          if (!selectedLogos.length) {
            logoRow.slideUp(200);
            return;
          }

          $.each(selectedLogos, function (index, logo) {
            var image = $(
              '<div class="col-wrapper col-wrapper-sixth">' +
                '<figure class="cart-product__logo-img__figure">' +
                '<div class="img product-image-holder" data-imageid="' +
                logo.id +
                '" style="background-image:url(' +
                logo.src +
                ')"></div>' +
                '</figure>' +
                '</div>'
            );
            logoRow.find('.col-wrapper-sixth').last().after(image);
          });
        })
        .always(function () {
          loader.hide();
        });
    };

    OfferPageView.prototype.removeLogos = function () {
      var productEl = $(this).closest('.cart-product');
      var productNumber = productEl.data('product-number');

      _this.updateLogos(productEl, productNumber, []);
    };

    // TODO rework and move to module.
    OfferPageView.prototype.toggleLogoInput = function () {
      var productEl = $(this).closest('.cart-product');
      var productNumber = productEl.data('product-number');
      var overlay = new OverlayBox(settings.templates.applicatelogos, settings.applicateMyLogos);

      overlay.setup();
      overlay.load();
      overlay.show();

      overlay.container.children('.overlay-box__inner-wrapper').addClass('box-90-scroll');

      $('.overlay-box__close-button').one('click', function (event) {
        event.preventDefault();
        overlay.destroy();
      });

      var closeFolder = function () {
        var folderID = $('#folder-container-root').data('folder-id');
        $('#folder-container-' + folderID).removeClass('selected');
        $('#main-listing').removeClass('hide');
        $('#folder-' + folderID).addClass('hide');
      };

      var openFolder = function (folderID) {
        closeFolder();
        $('#main-listing').addClass('hide');
        $('#folder-' + folderID).removeClass('hide');
        $('#folder-container-' + folderID).addClass('selected');
        $('#folder-container-root').data('folder-id', folderID);
      };

      $(overlay).on('dataLoaded', function () {
        _this.logoSelectBind();

        $('.logoapplication-addlogos').on('click', '.folder-container-subfolder', function (e) {
          e.preventDefault();
          openFolder($(this).data('folder-id'));
        });

        $('.logoapplication-addlogos').on('click', '#folder-container-root', function (e) {
          e.preventDefault();
          closeFolder();
        });

        $('.closeLogoSelect').one('click', function (event) {
          event.preventDefault();
          var selectedLogos = [];
          $('div.selected > .img').each(function (i) {
            var x = {
              id: $(this).data('logoid'),
              src: $(this).data('src')
            };
            selectedLogos.push(x);
          });
          _this.updateLogos(productEl, productNumber, selectedLogos);
          overlay.destroy();
        });

        var preSelected = productEl.find('.cart-product__logos .product-image-holder');

        $.each(preSelected, function (i, el) {
          selectedId = $(el).data('imageid');
          if (selectedId)
            $('#addMyLogos .img[data-logoid="' + selectedId + '"]')
              .parent('div')
              .addClass('selected');
        });
      });
    };

    OfferPageView.prototype.showMatrix = function (e) {
      var productEl = $(e.target).closest('.cart-product');
      var row = productEl.find('.matrix-row');
      if (row.is(':visible')) return;

      var productNumber = productEl.data('product-number');
      if (!_this.matrices[productNumber]) _this.insertMatrix(productEl, productNumber);

      row.slideDown(200);
    };

    OfferPageView.prototype.insertMatrix = function (productEl, productNumber) {
      var container = productEl.find('.matrix-container');
      var matrix = new OrderMatrix(container);

      matrix.setProductData(productNumber);
      matrix.onRender(function () {
        container.find('[data-loader]').hide();
      });
      matrix.load();
      _this.matrices[productNumber] = matrix;
    };

    OfferPageView.prototype.applyMatrix = function (e) {
      var productEl = $(e.target).closest('.cart-product');
      var productNumber = productEl.data('product-number');
      var matrixInputData = _this.matrices[productNumber].getProductInput(true);
      var loader = productEl.find('[data-product-loader]');

      ProductConnection.getProductImages(productNumber).then(function (res) {
        colorImages = !res || !res.color ? [] : res.color;
        var itemData = [];

        $.each(matrixInputData, function (i, inputData) {
          var colorImage = colorImages.filter(function (ci) {
            return ci.colorName === inputData.color;
          });
          var imgUrl = '';
          if (colorImage.length >= 1 && colorImage[0].images.length >= 1) imgUrl = colorImage[0].images[0].src;
          if (imgUrl === '' && colorImages.length >= 1 && colorImages[0].images.length >= 1)
            imgUrl = colorImages[0].images[0].src;
          inputData.imageUrl = imgUrl;

          itemData.push(inputData);
        });

        loader.show();
        OfferConnection.add({
          offerId: _this.offerId,
          skuQuantityList: itemData
        })
          .then(function (offerResult) {
            $.each(itemData, function (i, itemData) {
              var itemRows = productEl.find('.cart-product__item[data-sku]');
              var row = itemRows.filter('[data-sku="' + itemData.sku + '"]');
              if (row.length) {
                var qtyEl = row.find('.cart-article__quantity');
                qtyEl.val(parseInt(qtyEl.val(), 10) + parseInt(itemData.quantity, 10));
              } else {
                row = itemRows.first().clone();
                _this.populateItemRow(row, itemData);

                itemRows.last().after(row);
              }

              var matrix = productEl.find('.matrix-row');
              matrix.slideUp(200);
            });
            _this.updateOfferValues(offerResult);
          })
          .always(function () {
            loader.hide();
          });
      });
    };

    OfferPageView.prototype.populateItemRow = function (itemEl, data) {
      itemEl.attr('data-sku', data.sku);
      itemEl.find('.product-image-holder').css('background-image', 'url(' + data.imageUrl + ')');
      itemEl.find('strong').text(data.color + ' / ' + data.size);
      itemEl.find('.faded-text').text(data.sku);
      itemEl.find('.cart-article__quantity').val(data.quantity);
      return itemEl;
    };

    OfferPageView.prototype.updateOfferSum = function (sum) {
      $('#sum__markup').text(sum.markup);
      $('#sum__percent').text(sum.percent);
      $('#sum__total-nocosts').text(sum.totalPriceWithoutAdditionalCosts);
      $('#sum__costs').text(sum.additionalCosts);
      $('#sum__total').text(sum.totalPrice);
      $('.cart-product__percent-all').val(sum.percent);

      _this.dirtyPreview = true;
    };

    OfferPageView.prototype.getLogoTemplate = function (URL, value, imageType) {
      console.log(imageType);

      return $(
        '<img src="' +
          URL +
          '" data-select-image-value="' +
          value +
          '" data-select-image="' +
          imageType +
          '" alt="" class="coverimage" />'
      );
    };

    return OfferPageView;
  })();

  return View('OfferPageView', function () {
    var ov = new OfferPageView();
    ov._init();
  });
});

